import styles from './BgVideos.module.css';

import posterDefault from '../../assets/images/bgPoster.png';
import bgDefaultVideo from '../../assets/video/bgVideo.webm';

import leftVideo from '../../assets/video/left.webm';
import { useEffect, useRef } from 'react';

export const BgVideos = ({ currentState, message }) => {
  const fullVideoRef = useRef(null);
  useEffect(() => {
    const element = fullVideoRef.current;
    if (!element) return;

    let timer;

    if (['S2', 'S3'].includes(currentState) && message) {
      timer = setTimeout(() => {
        if (fullVideoRef.current) {
          fullVideoRef.current.classList.add(styles.unVisible);
        }
      }, 2000); // время на анимацию элементов
    } else if (currentState === 'S1' || !message || !currentState) {
      element.classList.remove(styles.unVisible);
    }

    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [currentState, message]);

  return (
    <div>
      <video
        ref={fullVideoRef}
        autoPlay="autoplay"
        muted="muted"
        loop
        playsInline
        poster={posterDefault}
        id="bgVideo"
        className={styles.fullVideo}
      >
        <source src={bgDefaultVideo} type="video/webm" />
      </video>

      <video
        autoPlay="autoplay"
        muted="muted"
        loop
        playsInline
        className={styles.leftVideo}
      >
        <source src={leftVideo} type="video/webm" />
      </video>
    </div>
  );
};
